import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
     Copyright © {new Date().getFullYear()} - ESTEIO Engenharia e Aerolevantamentos S.A. - Todos os Direitos Reservados
    </footer>
  );
};

export default Footer;
